"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const _4d_mapper_1 = require("4d-mapper");
const core_1 = require("@angular/core");
const material_1 = require("@angular/material");
const main_service_1 = require("../main.service");
class SharableComponent {
    constructor(dialogRef, mainService, fourD) {
        this.dialogRef = dialogRef;
        this.mainService = mainService;
        this.fourD = fourD;
        this.loading = true;
        this.transforms = null;
        this.V = null;
        this.V = this.fourD.V;
    }
    ngOnInit() {
        let me = this;
        this.getTransforms();
        // setTimeout( () => { me.loading = false; }, 3000 );
    }
    getTransforms() {
        let wms = this.fourD.transformTypes.find(t => t.uid == 'WMS');
        let wmsCheck = this.fourD.transformTypes.find(t => t.uid == 'wms_check');
        if (wms && wmsCheck) {
            let types = this.fourD.transformTypes.find(t => t.uid == 'WMS').id + '|' + this.fourD.transformTypes.find(t => t.uid == 'wms_check').id;
            const q = this.fourD.V.searchByObject(_4d_mapper_1.Transform).equals('account', this.fourD.activeTeam).equals('transformType', types).queryObservable().subscribe(res => {
                if (res.items.length) {
                    this.transforms = res.items;
                }
                this.loading = false;
            }, e => {
                this.loading = false;
            });
        }
        else {
            this.loading = false;
        }
    }
}
exports.SharableComponent = SharableComponent;
